import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OrganizationPartEffects } from './organization-part.effects';
import { organizationPartReducer } from './organization-part.reducer';
import { OrganizationPartService } from './organization-part.service';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature('organizationParts', organizationPartReducer),
        EffectsModule.forFeature([OrganizationPartEffects])
    ],
    providers: [OrganizationPartService]
})
export class OrganizationPartsModule {}
